import { render, staticRenderFns } from "./PersonCustomerRoleComponent.vue?vue&type=template&id=a91f1660"
import script from "./PersonCustomerRoleComponent.vue?vue&type=script&lang=js"
export * from "./PersonCustomerRoleComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports